import React, { Dispatch, SetStateAction } from "react";
import { IAddress } from "../../exports/interfaces";
import { dynamicSuccess } from "../../hooks/useToast";
import Select from "react-select";
import {
  customSelectStyles,
  SelectOption,
} from "../../exports/customSelectStyles";
// import { locationData } from "../../exports/location";
import { useOption } from "../../context/OptionContext";

const Address = ({
  currentStep,
  address,
  setAddress,
}: {
  currentStep: number;
  address: IAddress;
  setAddress: Dispatch<SetStateAction<IAddress>>;
}) => {
  const { categories } = useOption();
  // const provinces = Array.isArray(locationData)
  //   ? locationData
  //   : Object.values(locationData || {});

  // const provinceOptions = provinces.map((province: any) => ({
  //   label: province.name,
  //   value: province.name,
  // }));

  // const selectedProvince: any = provinces.find(
  //   (province: any) => province.name === address.province,
  // );

  // const districtsRaw = selectedProvince?.districts ?? {};

  // const districts = Array.isArray(districtsRaw)
  //   ? districtsRaw
  //   : Object.values(districtsRaw);

  // const districtOptions = districts.map((district: any) => ({
  //   label: district.name,
  //   value: district.name,
  // }));

  // const selectedDistrict: any = districts.find(
  //   (d: any) => d.name === address.district,
  // );

  // const municipalitiesRaw = selectedDistrict?.municipalities ?? {};

  // const municipalities = Array.isArray(municipalitiesRaw)
  //   ? municipalitiesRaw
  //   : Object.values(municipalitiesRaw);

  // const municipalityOptions = municipalities.map((district: any) => ({
  //   label: district.name,
  //   value: district.name,
  // }));
  // const selectedMunicipality: any = municipalities.find(
  //   (m: any) => m.name === address.municipality,
  // );
  // const wardsRaw = selectedMunicipality?.wards ?? [];

  // const wardOptions = (
  //   Array.isArray(wardsRaw) ? wardsRaw : Object.values(wardsRaw)
  // ).map((ward: any) => ({
  //   label: ward.toString(),
  //   value: ward.toString(),
  // }));

  const provinceOptions =
    categories
      ?.find((item) => item.name === "Province")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const districtOptions =
    categories
      ?.find((item) => item.name === "District")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const municipalityOptions =
    categories
      ?.find((item) => item.name === "Municipality (Local Level)")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const wardOptions =
    categories
      ?.find((item) => item.name === "Ward")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    setAddress((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (
    name: keyof IAddress,
    selected: SelectOption | null,
  ) => {
    setAddress((prev) => ({
      ...prev,
      [name]: name === "ward" ? Number(selected?.value) : selected?.value || "",
    }));
  };
  return (
    <>
      <div
        className={`dashboard-card ${currentStep !== 2 ? "mt-2" : ""}`}
        style={currentStep === 2 ? { borderTopLeftRadius: 0 } : {}}
      >
        <div className="row g-3">
          <div className="col-12">
            <h5>Address Information</h5>
            <div className="dashboard-card mt-3">
              <div className="row g-4">
                <div className="col-md-4">
                  <label className="form-label">
                    Province <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={provinceOptions}
                    placeholder="Select cooperative province"
                    value={
                      provinceOptions.find(
                        (option) => option.value === address.province,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("province", selected)
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    District <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={districtOptions}
                    placeholder="Select cooperative district"
                    value={
                      districtOptions.find(
                        (option) => option.value === address.district,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("district", selected)
                    }
                    noOptionsMessage={() =>
                      !address.province ? "Select province" : "No options"
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Municipality(Local Level){" "}
                    <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={municipalityOptions}
                    placeholder="Select municipality"
                    value={
                      municipalityOptions.find(
                        (option) => option.value === address.municipality,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("municipality", selected)
                    }
                    noOptionsMessage={() =>
                      !address.district ? "Select district" : "No options"
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Street\Tole <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Street\tole. here"
                    name="streetTole"
                    value={address.streetTole}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Ward <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={wardOptions}
                    placeholder="Select ward"
                    value={
                      wardOptions.find(
                        (option) => Number(option.value) === address.ward,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("ward", selected)
                    }
                    noOptionsMessage={() =>
                      !address.municipality
                        ? "Select municipality"
                        : "No options"
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
              </div>
              <div className="d-flex mt-4 justify-content-end">
                <button
                  className="btn btn-badge-primary px-3"
                  onClick={() => {
                    localStorage.setItem("address", JSON.stringify(address));
                    dynamicSuccess("Address saved as draft!");
                  }}
                >
                  Save Address
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Address;
